import { CSSProperties } from 'react';

import { ButtonStyleAddon } from '~/app/lib/songwhipApi/types';
import { isColorLight, toRgba } from '~/app/lib/utils/color';

export const toButtonStyleCss = (
  addon: ButtonStyleAddon = {}
): CSSProperties => {
  const { shape = 'round', fill, border, text } = addon;

  const borderRadius = (() => {
    switch (shape) {
      case 'round':
        return '9999px';
      case 'soft':
        return '1rem';
      case 'square':
        return '0';
    }
  })();

  return {
    color:
      text?.color ??
      (fill?.color ? (isColorLight(fill.color) ? '#000' : '#fff') : undefined),

    borderRadius,
    borderWidth: border?.width,
    borderColor: border?.color,

    backgroundColor: fill ? toRgba(fill.color, fill.opacity / 100) : undefined,
  };
};
